/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ValidateDealSalesStagesQueryResponse,
  ValidateDealSalesStagesPathParams,
  ValidateDealSalesStages404,
  ValidateDealSalesStages422,
} from '../types/ValidateDealSalesStages'

function getValidateDealSalesStagesUrl({
  import_number,
}: {
  import_number: ValidateDealSalesStagesPathParams['import_number']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/${import_number}/validate-deal-sales-stages/` as const,
  }
  return res
}

/**
 * @summary Validate deal sales-stage names against company sales stages
 * {@link /api/v1/importengine/previews/v2/:import_number/validate-deal-sales-stages/}
 */
export async function validateDealSalesStages(
  {
    import_number,
  }: { import_number: ValidateDealSalesStagesPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ValidateDealSalesStagesQueryResponse,
    ResponseErrorConfig<
      ValidateDealSalesStages404 | ValidateDealSalesStages422
    >,
    unknown
  >({
    method: 'GET',
    url: getValidateDealSalesStagesUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
